import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import Form from "../../components/common/form/Form";
import {transactionTypeSchema} from "../../schema/transactionTypeSchema";
import {getFormData} from "../../models/transactionTypeModel";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {createTransacationType} from "../../store/transaction-type-slice";

const TransactionTypeAdd = () => {
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const userRole = useSelector((state) => state.auth.selectedRole);
    const {
        createStatus,
        error
    } = useSelector(state => state.transactionType);

    useEffect(() => {
        if (createStatus === "success") {
            navigator(".."); // Adjust the navigation path as needed
        }
    }, [createStatus, navigator]);

    const formSubmitHandler = (data) => {
        delete data.systemGen;
        dispatch(createTransacationType({...userRole, data}))
    }

    const formCancelHandler = () => {
        navigator(".."); // Adjust the navigation path as needed
    };

    const initialData = getFormData()
    const schema = transactionTypeSchema();
    return (
        <>
            <SubHeader title="Add Transaction Type">
                <Button to=".." className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        <Form
                            onFormSubmit={formSubmitHandler}
                            onFormCancel={formCancelHandler}
                            schema={schema}
                            inline={false}
                            initialData={initialData}
                            status={createStatus}
                            error={error}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default TransactionTypeAdd;